/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPDOCUMENTTYPE } from './IAPDOCUMENTTYPE';
import {
    IAPDOCUMENTTYPEFromJSON,
    IAPDOCUMENTTYPEFromJSONTyped,
    IAPDOCUMENTTYPEToJSON,
} from './IAPDOCUMENTTYPE';
import type { IAPMIMETYPE } from './IAPMIMETYPE';
import {
    IAPMIMETYPEFromJSON,
    IAPMIMETYPEFromJSONTyped,
    IAPMIMETYPEToJSON,
} from './IAPMIMETYPE';

/**
 * 
 * @export
 * @interface SupportingDocumentViewModel
 */
export interface SupportingDocumentViewModel {
    /**
     * 
     * @type {number}
     * @memberof SupportingDocumentViewModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof SupportingDocumentViewModel
     */
    fileSize?: number;
    /**
     * 
     * @type {number}
     * @memberof SupportingDocumentViewModel
     */
    productId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SupportingDocumentViewModel
     */
    isSelectedForSigning: boolean;
    /**
     * 
     * @type {string}
     * @memberof SupportingDocumentViewModel
     */
    documentName?: string;
    /**
     * 
     * @type {IAPDOCUMENTTYPE}
     * @memberof SupportingDocumentViewModel
     */
    documentType?: IAPDOCUMENTTYPE;
    /**
     * 
     * @type {IAPMIMETYPE}
     * @memberof SupportingDocumentViewModel
     */
    mimeType: IAPMIMETYPE;
    /**
     * 
     * @type {Array<number>}
     * @memberof SupportingDocumentViewModel
     */
    signatoryIds: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof SupportingDocumentViewModel
     */
    fileAsBase64?: string;
    /**
     * 
     * @type {string}
     * @memberof SupportingDocumentViewModel
     */
    contentManagerItemId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SupportingDocumentViewModel
     */
    isGenerated?: boolean;
}

/**
 * Check if a given object implements the SupportingDocumentViewModel interface.
 */
export function instanceOfSupportingDocumentViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "isSelectedForSigning" in value;
    isInstance = isInstance && "mimeType" in value;
    isInstance = isInstance && "signatoryIds" in value;

    return isInstance;
}

export function SupportingDocumentViewModelFromJSON(json: any): SupportingDocumentViewModel {
    return SupportingDocumentViewModelFromJSONTyped(json, false);
}

export function SupportingDocumentViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportingDocumentViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'fileSize': !exists(json, 'FileSize') ? undefined : json['FileSize'],
        'productId': !exists(json, 'ProductId') ? undefined : json['ProductId'],
        'isSelectedForSigning': json['IsSelectedForSigning'],
        'documentName': !exists(json, 'DocumentName') ? undefined : json['DocumentName'],
        'documentType': !exists(json, 'DocumentType') ? undefined : IAPDOCUMENTTYPEFromJSON(json['DocumentType']),
        'mimeType': IAPMIMETYPEFromJSON(json['MimeType']),
        'signatoryIds': json['SignatoryIds'],
        'fileAsBase64': !exists(json, 'FileAsBase64') ? undefined : json['FileAsBase64'],
        'contentManagerItemId': !exists(json, 'ContentManagerItemId') ? undefined : json['ContentManagerItemId'],
        'isGenerated': !exists(json, 'IsGenerated') ? undefined : json['IsGenerated'],
    };
}

export function SupportingDocumentViewModelToJSON(value?: SupportingDocumentViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'FileSize': value.fileSize,
        'ProductId': value.productId,
        'IsSelectedForSigning': value.isSelectedForSigning,
        'DocumentName': value.documentName,
        'DocumentType': IAPDOCUMENTTYPEToJSON(value.documentType),
        'MimeType': IAPMIMETYPEToJSON(value.mimeType),
        'SignatoryIds': value.signatoryIds,
        'FileAsBase64': value.fileAsBase64,
        'ContentManagerItemId': value.contentManagerItemId,
        'IsGenerated': value.isGenerated,
    };
}

